import { MemberState } from '../interface/MemberInterface'

export default function (state: MemberState = {}, action) {
    let propertyName: string;

    switch (action.type) {
        case "LOAD_MEMBERS":
            propertyName = "MemberList";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_MEMBER_DETAIL":
            propertyName = "SelectedMember";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "ADD_INVOICE":
            propertyName = "EmployeeProfileInfo";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "UNLOAD_MEMBERS":
            propertyName = "MemberList";
            var newState = Object.assign({}, state);
            newState[propertyName] = null;
            return newState;
/*
        case "EDIT_INVOICE":
            propertyName = "EmployeeProfile1";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "ADD_MOU":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EDIT_MOU":
            return action.payload;
        case "ADD_CONTACT":
            propertyName = "EmployeeProfile2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "EDIT_CONTACT":
            propertyName = "EmployeeMatchRate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
*/
        default:
            return state;
    }
}